// @flow
import * as React from 'react';
import { Form, Input, Select, InputNumber, Switch, Tabs } from 'antd';
import { connect } from 'react-redux';
import { setFormValue } from '../State/form';

const { TextArea } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

type Props = {
  form: {},
  setFormValue: (key: string, value: any) => void,
}

class SupplierForm extends React.PureComponent<Props> {

  render() {
    const { form, setFormValue } = this.props;

    return (
      <Tabs defaultActiveKey="1">
        <TabPane tab="Company Details" key="1">
          <Form layout="vertical">
            <Form.Item label="Company Name" required>
              <Input
                value={form.company_name}
                onChange={(e) => setFormValue('company_name', e.target.value)}
                placeholder="Enter company name"
              />
            </Form.Item>

            <Form.Item label="Trading Name">
              <Input
                value={form.trading_name}
                onChange={(e) => setFormValue('trading_name', e.target.value)}
                placeholder="Enter trading name (if different)"
              />
            </Form.Item>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <Form.Item label="Company Registration">
                <Input
                  value={form.company_registration}
                  onChange={(e) => setFormValue('company_registration', e.target.value)}
                  placeholder="Company number"
                />
              </Form.Item>

              <Form.Item label="VAT Number">
                <Input
                  value={form.vat_number}
                  onChange={(e) => setFormValue('vat_number', e.target.value)}
                  placeholder="VAT number"
                />
              </Form.Item>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <Form.Item label="Email">
                <Input
                  type="email"
                  value={form.email}
                  onChange={(e) => setFormValue('email', e.target.value)}
                  placeholder="contact@supplier.com"
                />
              </Form.Item>

              <Form.Item label="Phone">
                <Input
                  value={form.phone}
                  onChange={(e) => setFormValue('phone', e.target.value)}
                  placeholder="Phone number"
                />
              </Form.Item>
            </div>

            <Form.Item label="Website">
              <Input
                value={form.website}
                onChange={(e) => setFormValue('website', e.target.value)}
                placeholder="https://www.supplier.com"
              />
            </Form.Item>

            <Form.Item label="Active">
              <Switch
                checked={form.active}
                onChange={(checked) => setFormValue('active', checked)}
              />
            </Form.Item>
          </Form>
        </TabPane>

        <TabPane tab="Address" key="2">
          <Form layout="vertical">
            <Form.Item label="Address Line 1">
              <Input
                value={form.address_line_1}
                onChange={(e) => setFormValue('address_line_1', e.target.value)}
                placeholder="Street address"
              />
            </Form.Item>

            <Form.Item label="Address Line 2">
              <Input
                value={form.address_line_2}
                onChange={(e) => setFormValue('address_line_2', e.target.value)}
                placeholder="Additional address info"
              />
            </Form.Item>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <Form.Item label="City">
                <Input
                  value={form.city}
                  onChange={(e) => setFormValue('city', e.target.value)}
                  placeholder="City"
                />
              </Form.Item>

              <Form.Item label="County">
                <Input
                  value={form.county}
                  onChange={(e) => setFormValue('county', e.target.value)}
                  placeholder="County"
                />
              </Form.Item>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <Form.Item label="Postcode">
                <Input
                  value={form.postcode}
                  onChange={(e) => setFormValue('postcode', e.target.value)}
                  placeholder="Postcode"
                />
              </Form.Item>

              <Form.Item label="Country">
                <Input
                  value={form.country}
                  onChange={(e) => setFormValue('country', e.target.value)}
                  placeholder="Country"
                />
              </Form.Item>
            </div>
          </Form>
        </TabPane>

        <TabPane tab="Business Terms" key="3">
          <Form layout="vertical">
            <Form.Item label="Payment Terms">
              <Input
                value={form.payment_terms}
                onChange={(e) => setFormValue('payment_terms', e.target.value)}
                placeholder="e.g., Net 30, COD, Net 60"
              />
            </Form.Item>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <Form.Item label="Default Lead Time (Days)">
                <InputNumber
                  value={form.default_lead_time_days}
                  onChange={(value) => setFormValue('default_lead_time_days', value)}
                  placeholder="Lead time in days"
                  min={0}
                  style={{ width: '100%' }}
                />
              </Form.Item>

              <Form.Item label="Default Currency">
                <Select
                  value={form.default_currency}
                  onChange={(value) => setFormValue('default_currency', value)}
                  placeholder="Select currency"
                >
                  <Option value="GBP">GBP (£)</Option>
                  <Option value="EUR">EUR (€)</Option>
                  <Option value="USD">USD ($)</Option>
                </Select>
              </Form.Item>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <Form.Item label="Default Tax Rate (%)">
                <InputNumber
                  value={form.default_tax_rate}
                  onChange={(value) => setFormValue('default_tax_rate', value)}
                  placeholder="VAT/Tax rate"
                  min={0}
                  max={100}
                  step={0.01}
                  style={{ width: '100%' }}
                />
              </Form.Item>

              <Form.Item label="Credit Limit">
                <InputNumber
                  value={form.credit_limit}
                  onChange={(value) => setFormValue('credit_limit', value)}
                  placeholder="Credit limit"
                  min={0}
                  step={100}
                  formatter={value => `£ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={value => value.replace(/£\s?|(,*)/g, '')}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </div>

            <Form.Item label="Account Number">
              <Input
                value={form.account_number}
                onChange={(e) => setFormValue('account_number', e.target.value)}
                placeholder="Your account number with this supplier"
              />
            </Form.Item>

            <Form.Item label="Notes">
              <TextArea
                value={form.notes}
                onChange={(e) => setFormValue('notes', e.target.value)}
                placeholder="Additional notes about this supplier"
                rows={4}
              />
            </Form.Item>
          </Form>
        </TabPane>
      </Tabs>
    );
  }
}

const mapStateToProps = (state) => ({
  form: state.modals.Supplier.form,
});

const actionCreators = {
  setFormValue,
};

export default connect(mapStateToProps, actionCreators)(SupplierForm);
